import { createApiMutation, createApiQuery } from '@/features/api'

import type { AuthzTeamFormDto, IAuthzScope, IAuthzTeam } from './type'

export const AUTHZ_KEY = {
	TEAM_LIST: '/authz/team/list',
	TEAM_DETAIL: '/authz/team/detail',
	TEAM_CREATE: '/authz/team/create',
	TEAM_UPDATE: '/authz/team/update',
	TEAM_DELETE: '/authz/team/delete',

	SCOPE_LIST: '/authz/scope/list',
}

/* ---------------------------------- TEAM ---------------------------------- */

export const authzTeamList = createApiQuery<{
	result: { teams: IAuthzTeam[]; total: number }
}>(AUTHZ_KEY.TEAM_LIST)

export const authzTeamDetail = createApiQuery<{
	params: { id: string }
	result: { team: IAuthzTeam }
}>(AUTHZ_KEY.TEAM_DETAIL)

export const authzTeamCreate = createApiMutation<{
	body: AuthzTeamFormDto
	result: { id: string }
}>(AUTHZ_KEY.TEAM_CREATE, { method: 'post' })

export const authzTeamUpdate = createApiMutation<{
	params: { id: string }
	body: AuthzTeamFormDto & { id: string }
	result: { id: string }
}>(AUTHZ_KEY.TEAM_UPDATE, { method: 'put' })

export const authzTeamDelete = createApiMutation<{ params: { id: string } }>(
	AUTHZ_KEY.TEAM_DELETE,
	{ method: 'delete' }
)

/* ---------------------------------- SCOPE --------------------------------- */

export const authzScopeList = createApiQuery<{
	result: IAuthzScope[]
}>(AUTHZ_KEY.SCOPE_LIST)
